import { render, staticRenderFns } from "./leftPage.vue?vue&type=template&id=207264ad&scoped=true"
import script from "./leftPage.vue?vue&type=script&lang=js"
export * from "./leftPage.vue?vue&type=script&lang=js"
import style0 from "./leftPage.vue?vue&type=style&index=0&id=207264ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207264ad",
  null
  
)

export default component.exports